module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.loadedPages === 0 ? 'Подробно' : 'Кратко ',
      "expandable": !((this.topCount > this.items.length) && _vm.isLoaded) && this.count > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchTitle()
      }
    }
  }, [_c('div', [_vm._v("\n        Долговых обязательств открыто "), _c('b', [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), (this.sumAmount != null) ? _c('div', [_vm._v("\n            Сумма долга\n            "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(this.sumAmount))
    }
  })])]) : _vm._e(), _vm._v(" "), (this.sumRemaining != null) ? _c('div', [_vm._v("\n            Сумма текущего долга\n            "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(this.sumRemaining))
    }
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.isLoading || this.items.length > 0) ? _c('v-panel-text', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.isLoaded ? 'Кратко ' : 'Еще ',
      "expandable": !((this.topCount > this.items.length) && _vm.isLoaded)
    },
    on: {
      "click": function($event) {
        return _vm.switchText()
      }
    }
  }, [_c('div', [_vm._l((_vm.items), function(item) {
    return [_c('div', [_c('div', [_c('b', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.enforcementNumber) + " ")]), _vm._v(" от " + _vm._s(_vm.formats.blank(item.institutionDate, _vm.formats.formatDate)) + "\n            ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n            Кредитор: "), (item.collectorRef) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.collectorRef, '_blank'))
      }
    }) : _vm._e(), _vm._v(" "), (!item.collectorRef) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (item.collectorRef) ? _c(_vm.renderFlags(item.collectorRef.flags, true), {
      tag: "v-component"
    }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_c('b', [_vm._v("Задолженность")]), _vm._v(" была/сейчас: "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(item.amount))
      }
    }), _vm._v("/"), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(item.remaining))
      }
    })]), _vm._v(" - " + _vm._s(item.executionObject) + ".\n            ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.department))])])], 1)]
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10e2a88a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/EnforcementDebtsPanel.vue
// module id = 1057
// module chunks = 1